// Self-hosted consent gate for analytics/marketing trackers (CIPA Phase 1).
const STORAGE_KEY = 'dsp_cookie_consent';
const CONSENT_VERSION = 1;
const GTM_ID = 'GTM-TMSFK4LJ';
const ROKU_ID = 'PaccoeeYVtrN';

let trackersLoaded = false;

export function getConsent() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && (parsed.state === 'granted' || parsed.state === 'denied') ? parsed.state : null;
  } catch (e) {
    return null;
  }
}

export function setConsent(state) {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ state, ts: Date.now(), v: CONSENT_VERSION }),
    );
  } catch (e) {
    /* localStorage unavailable — fail closed */
  }
}

export function clearConsent() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    /* no-op */
  }
}

export function gtagConsentUpdate(state) {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag('consent', 'update', {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
    analytics_storage: state,
  });
}

export function loadTrackers() {
  if (trackersLoaded) return;
  trackersLoaded = true;
  try {
    // Google Tag Manager
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const gtm = document.createElement('script');
    gtm.async = true;
    gtm.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    gtm.setAttribute('data-consent-tracker', 'gtm');
    document.head.appendChild(gtm);

    // Roku pixel — canonical queue stub. It MUST define `load`: the hosted
    // rkp.loader.js calls rkp.load(...) during its own init, so omitting it
    // throws "rkp.load is not a function" (seen cross-origin as "Script error.").
    (function (w, d) {
      if (!w.rkp) {
        const t = function () {
          const args = Array.prototype.slice.call(arguments);
          args.push(Date.now());
          if (t.eventProcessor) t.eventProcessor.apply(t, args);
          else t.queue.push(args);
        };
        t.initiatorVersion = '1.0';
        t.queue = [];
        t.load = function (src) {
          const s = d.createElement('script');
          s.async = true;
          s.src = src;
          s.setAttribute('data-consent-tracker', 'roku');
          const n = d.getElementsByTagName('script')[0];
          if (n && n.parentNode) n.parentNode.insertBefore(s, n);
          else d.head.appendChild(s);
        };
        w.rkp = t;
        t.load('https://cdn.ravm.tv/ust/dist/rkp.loader.js');
      }
    })(window, document);
    window.rkp('init', ROKU_ID);
    window.rkp('event', 'PAGE_VIEW');

    gtagConsentUpdate('granted');
  } catch (e) {
    /* tracking is best-effort; never break the app */
  }
}
